import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: number;
  name: string;
  email: string;
  administrator: boolean;
}

interface AuthState {
  token: string | null;
  user: User | null;
  // Impersonacja admina (2026-09-20) — gdy aktywna, `token`/`user` powyżej
  // to sesja KLIENTA (podglądowa), a oryginalna sesja admina jest
  // zachowana TUTAJ, w osobnych polach, nigdy nie nadpisana — to na to
  // wraca "Wróć do panelu admina" (stopImpersonation).
  impersonating: boolean;
  originalAdminToken: string | null;
  originalAdminUser: User | null;
  setAuth: (token: string, user: User) => void;
  startImpersonation: (token: string, user: User) => void;
  stopImpersonation: () => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      impersonating: false,
      originalAdminToken: null,
      originalAdminUser: null,
      setAuth: (token, user) => {
        localStorage.setItem('token', token);
        set({ token, user });
      },
      startImpersonation: (token, user) => {
        const { token: adminToken, user: adminUser } = get();
        localStorage.setItem('token', token);
        set({
          token,
          user,
          impersonating: true,
          originalAdminToken: adminToken,
          originalAdminUser: adminUser,
        });
      },
      stopImpersonation: () => {
        const { originalAdminToken, originalAdminUser } = get();
        if (originalAdminToken) {
          localStorage.setItem('token', originalAdminToken);
        }
        set({
          token: originalAdminToken,
          user: originalAdminUser,
          impersonating: false,
          originalAdminToken: null,
          originalAdminUser: null,
        });
      },
      logout: () => {
        localStorage.removeItem('token');
        set({
          token: null,
          user: null,
          impersonating: false,
          originalAdminToken: null,
          originalAdminUser: null,
        });
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);
